import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, Toast, ToastBody, ToastHeader } from "reactstrap";
import DocsTooltip from "components/Common/DocsTooltip";
import { Link, useLocation } from "react-router-dom";
import { getRedirectSlack as onGetRedirectSlack } from "../../store/actions";
// Pages Components
import LatestTranaction from "./Services";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux

const Service = props => {

  //meta title
  document.title = "Application Services | Temperstack";
  const domain = window.location.hostname;

  const dispatch = useDispatch();
  const location = useLocation();
  const [toast, setToast] = useState(true);
  const [slackInstallationSuccess, setSlackInstallationSuccess] = useState(null);
  const [servicesTooltip, setServicesTooltip] = useState(false);
  const [slackTooltip, setSlackTooltip] = useState(false);
  const toggleToast = () => {
    setToast(!toast);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const installationSuccessParam = urlParams.get('slack_installation_success');
    if (installationSuccessParam === 'true') {
      setSlackInstallationSuccess(true);
    } else if (installationSuccessParam === 'false') {
      setSlackInstallationSuccess(false);
    } else {
      setSlackInstallationSuccess(null);
    }
    if (slackInstallationSuccess !== null) {
      const timeoutId = setTimeout(() => {
        setToast(false);
      }, 5000);
      return () => {
        // Clear the timeout if the component unmounts(UNMOUNTING)
        clearTimeout(timeoutId);
      };
    }
  }, [location.search, slackInstallationSuccess]);

  const { redirectSlack } = useSelector(state => ({
    redirectSlack: state.Service.redirectSlack
  }));

  useEffect(() => {
    dispatch(onGetRedirectSlack());
  }, [onGetRedirectSlack]);

  return (
    <React.Fragment>
      {slackInstallationSuccess !== null && (
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: "1005" }}>
          <Toast isOpen={toast}>
            <ToastHeader toggle={toggleToast}>
              {slackInstallationSuccess === true ? 'SUCCESS!' : 'FAIL!'}
            </ToastHeader>
            <ToastBody>
              {slackInstallationSuccess === true
                ? 'Slack Installation was successful'
                : 'Slack Installation Failed. Please try again!'}
            </ToastBody>
          </Toast>
        </div>
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row className="align-items-center">
            <Col lg="6" className="align-items-center">
              <div className="d-flex gap-1 align-items-start text-white">
                <Breadcrumbs
                  title={props.t("Application Services")}
                  breadcrumbItem={props.t("Application Services")}
                />
                <span>
                  <i role="button" className="bx bx-help-circle font-size-18" id="serviceTooltip" />
                </span>
              </div>
              <DocsTooltip 
                placement={'right'}
                isOpen={servicesTooltip}
                toggle={() => setServicesTooltip(!servicesTooltip)}
                targetId={'serviceTooltip'}
                multipleLinks={[{
                  linkText: "Setting up services",
                  link: "https://docs.temperstack.com/temperstack/platform/incident-command/setting-up-services"
                },
                {
                  linkText: "Alert notification channels",
                  link: "https://docs.temperstack.com/temperstack/platform/incident-command/alert-notification-channels"
                },
                {
                  linkText: "Test notifications",
                  link: "https://docs.temperstack.com/temperstack/platform/incident-command/testing-alerting-and-notifications"
                }
              ]}
              />
            </Col>
            <Col lg="6" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              {(domain === 'msteamtestaccount.temperstack.com' || domain == '10xengg.myapp.com' || domain.endsWith("temperstack.dev")) ? (
                <Link
                  to="/msteams"
                  style={{ marginRight: '1rem' }}
                >
                  <img src="https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/addToMSTeams.png" height="38" width="120" alt="Add To MS Teams" style={{ borderRadius: '5px' }} />
                </Link>) : null}
              <a id="slack" href={redirectSlack} target="_blank" rel="noreferrer" style={{ marginRight: '1rem' }}>
                <img alt="Add to Slack" height="36" width="120" src="https://platform.slack-edge.com/img/add_to_slack.png" />
              </a>
              <DocsTooltip 
                placement={'left'}
                isOpen={slackTooltip}
                toggle={() => setSlackTooltip(!slackTooltip)}
                targetId={'slack'}
                linkText={'Slack Integration?'}
                content={'Need help with'}
                link={'https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#slack-integration'}
              />
              <Link
                to="/add-service"
                className="btn btn-primary bx-pull-right w-md"
              >
                Add Service
              </Link>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <LatestTranaction />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Service.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Service);
